import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Импорт переводов
const resources = {
  en: {
    translation: {
      // Navigation items
      "nav.rentings": "Rentings",
      "nav.rent_calendar": "Rent Calendar",
      "nav.cars": "Cars",
      "nav.activities": "Activities",
      "nav.car_models": "Car Models",
      "nav.clients": "Clients",
      "nav.home": "Home",

      // Menu sections
      "menu.title": "Menu",
      "menu.version": "Version",
      "menu.production": "Production",
      "menu.staging": "Staging",
      "menu.site": "Site",
      "menu.piccolo": "Piccolo",

      // Settings
      "settings.menu_order.title": "Menu Order",
      "settings.menu_order.description": "Drag and drop menu items to change their order in the sidebar. On mobile devices, press and hold an item for a moment to start dragging. Changes are saved automatically.",

      // Filters
      "filters.columns": "Columns",

      // Cars section
      "cars.title": "Cars | Admin.Drivitive",
      "cars.description": "Manage cars",
      "cars.add_new": "Add New Car",
      "cars.columns.image": "Image",
      "cars.columns.info": "Info",
      "cars.columns.color": "Color",
      "cars.columns.price": "Price",
      "cars.columns.usage_stats": "Usage Stats",
      "cars.columns.actions": "Actions",
      "cars.actions.edit": "Edit",
      "cars.actions.details": "Details",
      "cars.view_car_details": "View car details",
      "cars.view_model_details": "View model details",
      "cars.stats.title": "Usage Statistics",
      "cars.stats.busy_days": "Busy Days",
      "cars.stats.free_days": "Free Days",
      "cars.stats.no_data": "No data",
      "cars.stats.all_time": "All time",
      "cars.stats.entire_year": "Entire {{year}}",
      "cars.stats.busy": "{{percentage}}% busy",
      "cars.details.title": "Car Details",
      "cars.details.actions": "Actions",
      "cars.details.information": "Information",
      "cars.details.english_description": "English description",
      "cars.details.french_description": "French description",
      "cars.details.delete.title": "Delete Car",
      "cars.details.delete.confirmation": "Are you sure you want to delete this car? This action cannot be undone.",
      "cars.details.delete.button": "Delete",
      "cars.details.delete.cancel": "Cancel",
      "cars.details.delete.deleting": "Deleting...",
      "cars.details.edit.button": "Edit Car",
      "cars.details.fields.year": "Year",
      "cars.details.fields.reg_number": "Reg. number",
      "cars.details.fields.color": "Color",
      "cars.details.fields.fuel_type": "Fuel type",
      "cars.details.fields.fuel_consumption": "Fuel consumption",
      "cars.details.fields.engine": "Engine",
      "cars.details.fields.seats": "Seats",
      "cars.details.fields.doors": "Doors",
      "cars.details.fields.drivetrain": "Drivetrain",
      "cars.details.fields.clearance": "Clear.",
      "cars.details.fields.price_per_day": "Price per day",
      "cars.details.fields.mileage_limit": "Mileage limit",
      "cars.details.fields.features": "Features",
      "cars.details.errors.loading": "Loading...",
      "cars.details.errors.error_loading": "Error loading car details",
      "cars.details.errors.model_not_found": "Error: Car model information not found",

      // Rentings section
      "rentings.title": "Rentings | Admin.Drivitive",
      "rentings.description": "Rentings list",
      "rentings.breadcrumb": "Rentings",
      "rentings.breadcrumb.renting": "Renting",
      "rentings.columns.id": "Renting Id",
      "rentings.columns.car": "Car",
      "rentings.columns.delivery": "Delivery",
      "rentings.columns.status": "Status",
      "rentings.columns.client": "Client",
      "rentings.columns.price": "Total Price",
      "rentings.columns.comments": "Comments",
      "rentings.columns.reports": "Reports",
      "rentings.columns.actions": "Actions",
      "rentings.columns.reports.delivery": "Delivery",
      "rentings.columns.reports.pickup": "Pickup",
      "rentings.filters.status.all": "All Statuses",
      "rentings.filters.status.draft": "Draft",
      "rentings.filters.status.confirmed": "Confirmed",
      "rentings.filters.status.finished": "Finished",
      "rentings.filters.status.cancelled": "Cancelled",
      "rentings.filters.car.all": "All Cars",
      "rentings.filters.status.placeholder": "Filter by Status",
      "rentings.filters.car.placeholder": "Filter by Car",
      "rentings.filters.loading_cars": "Loading cars...",
      "rentings.filters.reset": "Reset filters",
      "rentings.calendar.title": "Rent Calendar",
      "rentings.calendar.description": "Rent Calendar",

      // Renting comment form
      "rentings.comment.title": "Add Comment",
      "rentings.comment.description": "Add a comment to this renting",
      "rentings.comment.fields.comment": "Comment",
      "rentings.comment.fields.image": "Image (optional)",
      "rentings.comment.placeholders.enter_comment": "Enter your comment...",
      "rentings.comment.buttons.add": "Add Comment",
      "rentings.comment.buttons.adding": "Adding Comment...",
      "rentings.comment.errors.text_required": "Comment text is required",
      "rentings.comment.errors.create_failed": "Failed to create comment. Please try again.",

      // Renting edit form
      "rentings.edit.title": "Edit Renting",
      "rentings.edit.success": "Renting updated successfully",
      "rentings.edit.error": "Failed to update renting",
      "rentings.edit.description": "Update renting information",
      "rentings.edit.fields.client": "Client",
      "rentings.edit.fields.car": "Car",
      "rentings.edit.fields.start_date": "Start Date",
      "rentings.edit.fields.start_time": "Start Time",
      "rentings.edit.fields.end_date": "End Date",
      "rentings.edit.fields.end_time": "End Time",
      "rentings.edit.fields.delivery_address": "Delivery Address",
      "rentings.edit.fields.pickup_address": "Pickup Address",
      "rentings.edit.fields.delivery_latitude": "Delivery Latitude",
      "rentings.edit.fields.delivery_longitude": "Delivery Longitude",
      "rentings.edit.fields.pickup_latitude": "Pickup Latitude",
      "rentings.edit.fields.pickup_longitude": "Pickup Longitude",
      "rentings.edit.fields.total_price": "Total Price",
      "rentings.edit.fields.original_price": "Original Price",
      "rentings.edit.fields.currency": "Currency",
      "rentings.edit.placeholders.select_date": "Select date",
      "rentings.edit.placeholders.enter_delivery_address": "Enter delivery address",
      "rentings.edit.placeholders.enter_pickup_address": "Enter pickup address",
      "rentings.edit.placeholders.enter_latitude": "Enter latitude",
      "rentings.edit.placeholders.enter_longitude": "Enter longitude",
      "rentings.edit.placeholders.enter_total_price": "Enter total price",
      "rentings.edit.placeholders.enter_original_price": "Enter original price",
      "rentings.edit.buttons.update": "Update Renting",
      "rentings.edit.buttons.updating": "Updating...",
      "rentings.edit.errors.start_date_required": "Start date is required",
      "rentings.edit.errors.start_time_required": "Start time is required",
      "rentings.edit.errors.end_date_required": "End date is required",
      "rentings.edit.errors.end_time_required": "End time is required",
      "rentings.edit.errors.delivery_address_required": "Delivery address is required",
      "rentings.edit.errors.pickup_address_required": "Pickup address is required",
      "rentings.edit.errors.total_price_required": "Total price is required",
      "rentings.edit.errors.currency_required": "Currency is required",
      "rentings.edit.errors.end_after_start_required": "End date/time must be after start date/time",
      "rentings.edit.errors.update_failed": "Failed to update renting. Please try again.",

      // Renting date/time edit
      "rentings.datetime_edit.title.edit_start_datetime": "Edit Start Date & Time",
      "rentings.datetime_edit.title.edit_end_datetime": "Edit End Date & Time",
      "rentings.datetime_edit.description": "Update the date and time for this renting",
      "rentings.datetime_edit.fields.date": "Date",
      "rentings.datetime_edit.fields.time": "Time",
      "rentings.datetime_edit.buttons.update": "Update",
      "rentings.datetime_edit.buttons.updating": "Updating...",
      "rentings.datetime_edit.errors.date_required": "Date is required",
      "rentings.datetime_edit.errors.time_required": "Time is required",
      "rentings.datetime_edit.errors.future_datetime_required": "Date and time must be in the future",
      "rentings.datetime_edit.errors.update_failed": "Failed to update date/time. Please try again.",
      "rentings.datetime_edit.edit_start_datetime": "Edit start date/time",
      "rentings.datetime_edit.edit_end_datetime": "Edit end date/time",

      // Renting address edit
      "rentings.address_edit.title.edit_delivery_address": "Modifier l'adresse de livraison",
      "rentings.address_edit.title.edit_pickup_address": "Modifier l'adresse de récupération",
      "rentings.address_edit.description": "Mettre à jour l'adresse et les coordonnées pour cet emplacement",
      "rentings.address_edit.fields.address": "Adresse",
      "rentings.address_edit.fields.latitude": "Latitude",
      "rentings.address_edit.fields.longitude": "Longitude",
      "rentings.address_edit.placeholders.enter_address": "Entrer l'adresse",
      "rentings.address_edit.placeholders.enter_latitude": "Entrer la latitude",
      "rentings.address_edit.placeholders.enter_longitude": "Entrer la longitude",
      "rentings.address_edit.buttons.update": "Mettre à jour",
      "rentings.address_edit.buttons.updating": "Mise à jour...",
      "rentings.address_edit.errors.address_required": "L'adresse est requise",
      "rentings.address_edit.errors.latitude_required": "La latitude est requise",
      "rentings.address_edit.errors.longitude_required": "La longitude est requise",
      "rentings.address_edit.errors.latitude_invalid": "La latitude doit être comprise entre -90 et 90",
      "rentings.address_edit.errors.longitude_invalid": "La longitude doit être comprise entre -180 et 180",
      "rentings.address_edit.errors.update_failed": "Échec de la mise à jour de l'adresse. Veuillez réessayer.",
      "rentings.address_edit.edit_delivery_address": "Modifier l'adresse de livraison",
      "rentings.address_edit.edit_pickup_address": "Modifier l'adresse de récupération",

      // Pagination
      "pagination.previous": "Previous",
      "pagination.next": "Next",
      "pagination.ellipsis": "...",

      // Common translations
      "Loading...": "Loading...",
      "Error": "Error",
      "Confirm": "Confirm",
      "Cancel": "Cancel",
      "Save": "Save",
      "Edit": "Edit",
      "Delete": "Delete",
      "Close": "Close",
      "Yes": "Yes",
      "No": "No",
      "Back": "Back",
      "Next": "Next",
      "Search": "Search",
      "Filter": "Filter",
      "All": "All",
      "None": "None",
      "Details": "Details",
      "Actions": "Actions",
      "Status": "Status",
      "Date": "Date",
      "Time": "Time",
      "Price": "Price",
      "Total": "Total",
      "Original": "Original",
      "per day": "per day",
      "Period": "Period",
      "Client": "Client",
      "Contact info": "Contact info",
      "Created": "Created",
      "View details": "View details",
      "Color": "Color",
      "Year": "Year",
      "Reg. number": "Reg. number",
      "No comments": "No comments",
      "No extra services": "No extra services",
      "Add comment": "Add comment",
      "Confirming...": "Confirming...",
      "Canceling...": "Canceling...",
      "Yes, confirm it": "Yes, confirm it",
      "No, cancel": "No, cancel",
      "No, keep it": "No, keep it",
      "Yes, cancel it": "Yes, cancel it",
      "Edit Renting": "Edit Renting",
      "This action cannot be undone.": "This action cannot be undone.",
      "common.buttons.cancel": "Cancel",

      // Renting details page
      "Renting details": "Renting details",
      "Rental Details": "Rental Details",
      "Delivery Details": "Delivery Details",
      "Car": "Car",
      "Extra Services": "Extra Services",
      "Comments": "Comments",
      "Confirm Renting": "Confirm Renting",
      "Cancel Renting": "Cancel Renting",
      "Are you sure you want to confirm this renting?": "Are you sure you want to confirm this renting?",
      "Are you sure you want to cancel this renting?": "Are you sure you want to cancel this renting?",
      "Delivery Address": "Delivery Address",
      "Pickup Address": "Pickup Address",
      "Total price": "Total price",
      "Renting": "Renting",
      "Error loading renting details": "Error loading renting details",

      // Car Reports translations
      "Car Reports": "Car Reports",
      "Delivery Report": "Delivery Report",
      "Pickup Report": "Pickup Report",
      "Create Report": "Create Report",
      "Mileage": "Mileage",
      "Fuel Level": "Fuel Level",
      "No reports available": "No reports available",
      "Failed to load reports": "Failed to load reports",

      // Report Details Page
      "reports.details.title": "Report",
      "reports.details.description": "Report details",
      "reports.details.error_loading": "Error loading report details",
      "reports.details.report_details": "Report Details",
      "reports.details.edit_report": "Edit Report",
      "reports.details.report_type": "Report Type",
      "reports.details.delivery_report": "Delivery Report",
      "reports.details.pickup_report": "Pickup Report",
      "reports.details.for_renting": "for Renting",
      "reports.details.created_at": "Created At",
      "reports.details.employee": "Employee",
      "reports.details.mileage": "Mileage",
      "reports.details.fuel_level": "Fuel Level",
      "reports.details.charge_level": "Charge Level",
      "reports.details.renting_details": "Renting Details",
      "reports.details.client": "Client",
      "reports.details.period": "Period",
      "reports.details.delivery_address": "Delivery Address",
      "reports.details.pickup_address": "Pickup Address",
      "reports.details.car": "Car",
      "reports.details.view_car_details": "View car details",
      "reports.details.year": "Year",
      "reports.details.reg_number": "Reg. number",
      "reports.details.car_details": "Car Details",
      "reports.details.detail": "Detail",
      "reports.details.image": "image",
      "reports.details.print": "Print",

      // Date Range Filter Modal
      "date_range_filter.title": "Select Date Range",
      "date_range_filter.year": "Year",
      "date_range_filter.quarter": "Quarter",
      "date_range_filter.month": "Month",
      "date_range_filter.select_year_first": "Select year first",
      "date_range_filter.select_quarter_first": "Select quarter first",
      "date_range_filter.select_year_quarter_first": "Select year and quarter first",
      "date_range_filter.start_date": "Start Date",
      "date_range_filter.end_date": "End Date",
      "date_range_filter.apply": "Apply",

      // Car creation form
      "cars.create.title": "Add New Car",
      "cars.create.success": "Car created successfully",
      "cars.create.error": "Failed to create car",
      "cars.edit.title": "Edit Car",
      "cars.edit.success": "Car updated successfully",
      "cars.edit.error": "Failed to update car",
      "cars.create.subtitle": "Create new car",
      "cars.edit.subtitle": "Update the car",
      "cars.create.basic_info": "Basic Information",
      "cars.create.technical_specs": "Technical Specifications",
      "cars.create.descriptions": "Descriptions",
      "cars.create.permitted_area": "Permitted Area",
      "cars.create.interior_features": "Interior & Features",
      "cars.create.fields.car_image": "Car Image",
      "cars.create.fields.car_model": "Car Model",
      "cars.create.fields.reg_number": "Registration Number",
      "cars.create.fields.slug": "Slug",
      "cars.create.fields.color": "Color",
      "cars.create.fields.release_year": "Release Year",
      "cars.create.fields.price": "Price",
      "cars.create.fields.fuel_type": "Fuel Type",
      "cars.create.fields.drivetrain": "Drivetrain",
      "cars.create.fields.engine_displacement": "Engine Displacement (L)",
      "cars.create.fields.engine_power": "Engine Power (HP)",
      "cars.create.fields.fuel_consumption": "Fuel Consumption (L/100km)",
      "cars.create.fields.ecology_class": "Ecology Class",
      "cars.create.fields.english": "English",
      "cars.create.fields.french": "French",
      "cars.create.fields.gps": "GPS Navigation",
      "cars.create.fields.latitude": "Latitude",
      "cars.create.fields.longitude": "Longitude",
      "cars.create.fields.radius": "Radius (km)",
      "cars.create.fields.seats": "Seats",
      "cars.create.fields.doors": "Doors",
      "cars.create.fields.clearance": "Clear. (mm)",
      "cars.create.fields.mileage_limit": "Limit (km)",
      "cars.create.placeholders.select_model": "Select car model",
      "cars.create.placeholders.enter_reg_number": "Enter registration number",
      "cars.create.placeholders.enter_slug": "Enter slug",
      "cars.create.placeholders.select_color": "Select color",
      "cars.create.placeholders.enter_year": "Enter release year",
      "cars.create.placeholders.enter_price": "Enter price",
      "cars.create.placeholders.select_fuel_type": "Select fuel type",
      "cars.create.placeholders.select_drivetrain": "Select drivetrain",
      "cars.create.placeholders.enter_engine": "e.g. 2.0",
      "cars.create.placeholders.enter_power": "e.g. 150",
      "cars.create.placeholders.enter_consumption": "e.g. 7.5",
      "cars.create.placeholders.enter_ecology": "e.g. Euro 6",
      "cars.create.placeholders.enter_description_en": "Enter description in English",
      "cars.create.placeholders.enter_description_fr": "Enter description in French",
      "cars.create.placeholders.enter_latitude": "Enter latitude",
      "cars.create.placeholders.enter_longitude": "Enter longitude",
      "cars.create.placeholders.enter_radius": "Enter radius",
      "cars.create.placeholders.enter_seats": "Count",
      "cars.create.placeholders.enter_doors": "Count",
      "cars.create.placeholders.enter_clearance": "Height",
      "cars.create.placeholders.enter_mileage": "Per day",
      "cars.create.buttons.cancel": "Cancel",
      "cars.create.buttons.create": "Create Car",
      "cars.edit.buttons.update": "Update Car",
      "cars.create.errors.model_required": "Car model is required",
      "cars.create.errors.reg_number_required": "Registration number is required",
      "cars.create.errors.color_required": "Color is required",
      "cars.create.errors.price_required": "Valid price is required",
      "cars.create.errors.fuel_type_required": "Please select a fuel type",
      "cars.create.errors.drivetrain_required": "Please select a drivetrain",
      "cars.price_calendar.title": "Price Calendar",
      "cars.price_calendar.add_range_price": "Add Range Price",
      "cars.price_calendar.custom_price": "Custom Price",
      "cars.price_calendar.discount": "Discount",
      "cars.price_calendar.promotion": "Promotion",

      // Header translations
      "header.stage_badge": "Stage Admin",
      "header.toggle_sidebar": "Toggle Sidebar",
      "header.go_back": "Go back",
      "header.app_name": "Admin.Drivitive",
      "header.search_placeholder": "Search or type command...",
      "header.search_shortcut": "⌘ K",

      // User dropdown translations
      "user_dropdown.profile": "Profile",
      "user_dropdown.settings": "Settings",
      "user_dropdown.sign_out": "Sign out",
      "user_dropdown.account_settings": "Account settings",
      "user_dropdown.support": "Support",
      "user_dropdown.team": "Team",

      // Team section
      "team.title": "Team | Admin.Drivitive",
      "team.description": "Manage team administrators",
      "team.columns.name": "Name",
      "team.columns.email": "Email",
      "team.columns.role": "Role",
      "team.columns.actions": "Actions",
      "team.actions.edit": "Edit",
      "team.role.admin": "Admin",
      "team.role.seo": "SEO",
      "team.edit_user.title": "Edit User",
      "team.edit_user.name": "Name",
      "team.edit_user.email": "Email",
      "team.edit_user.role": "Role",
      "team.edit_user.save": "Save",
      "team.edit_user.cancel": "Cancel",

      // Car Models section
      "car_models.title": "Car Models | Admin.Drivitive",
      "car_models.description": "Manage car models",
      "car_models.add_new": "Add New Model",
      "car_models.columns.image": "Image",
      "car_models.columns.model": "Model",
      "car_models.columns.status": "Status",
      "car_models.columns.description": "Description",
      "car_models.columns.actions": "Actions",
      "car_models.actions.details": "Details",
      "car_models.status.active": "Active",
      "car_models.status.inactive": "Inactive",
      "car_models.description.english": "🇺🇸 English:",
      "car_models.description.french": "🇫🇷 French:",
      "car_models.details.title": "Car Model Details",
      "car_models.details.about": "About model",
      "car_models.details.edit": "Edit Model",
      "car_models.details.activate": "Activate",
      "car_models.details.deactivate": "Deactivate",
      "car_models.details.delete": "Delete",
      "car_models.details.slug": "Slug:",
      "car_models.details.body_type": "Body Type",
      "car_models.details.transmission": "Transmission",
      "car_models.details.english_description": "🇺🇸 English description",
      "car_models.details.french_description": "🇫🇷 French description",
      "car_models.details.no_description": "No description available",

      // Car Model Creation Form
      "car_models.create.title": "Create Car Model",
      "car_models.create.success": "Car model created successfully",
      "car_models.create.error": "Failed to create car model",
      "car_models.create.description": "Add new car model",
      "car_models.create.fields.image": "Model Image",
      "car_models.create.fields.slug": "Slug",
      "car_models.create.fields.brand_name": "Brand Name",
      "car_models.create.fields.model_name": "Model Name",
      "car_models.create.fields.transmission_type": "Transmission Type",
      "car_models.create.fields.body_type": "Body Type",
      "car_models.create.fields.description_en": "English Description",
      "car_models.create.fields.description_fr": "French Description",
      "car_models.create.placeholders.enter_slug": "Enter slug or it will be generated automatically",
      "car_models.create.placeholders.enter_brand_name": "Enter brand name",
      "car_models.create.placeholders.enter_model_name": "Enter model name",
      "car_models.create.placeholders.select_transmission": "Select transmission type",
      "car_models.create.placeholders.select_body_type": "Select body type",
      "car_models.create.placeholders.enter_description_en": "Enter description in English",
      "car_models.create.placeholders.enter_description_fr": "Enter description in French",
      "car_models.create.buttons.create": "Create Model",
      "car_models.create.errors.brand_name_required": "Brand name is required",
      "car_models.create.errors.model_name_required": "Model name is required",
      "car_models.create.errors.transmission_type_required": "Transmission type is required",
      "car_models.create.errors.body_type_required": "Body type is required",
      "car_models.create.image_alt": "Model preview",

      // Car Model Edit Form
      "car_models.edit.title": "Edit Car Model",
      "car_models.edit.success": "Car model updated successfully",
      "car_models.edit.error": "Failed to update car model",
      "car_models.edit.description": "Update car model details",
      "car_models.edit.fields.image": "Model Image",
      "car_models.edit.fields.slug": "Slug",
      "car_models.edit.fields.brand_name": "Brand Name",
      "car_models.edit.fields.model_name": "Model Name",
      "car_models.edit.fields.transmission_type": "Transmission Type",
      "car_models.edit.fields.body_type": "Body Type",
      "car_models.edit.fields.description_en": "English Description",
      "car_models.edit.fields.description_fr": "French Description",
      "car_models.edit.placeholders.enter_slug": "Enter slug or it will be generated automatically",
      "car_models.edit.placeholders.enter_brand_name": "Enter brand name",
      "car_models.edit.placeholders.enter_model_name": "Enter model name",
      "car_models.edit.placeholders.select_transmission": "Select transmission type",
      "car_models.edit.placeholders.select_body_type": "Select body type",
      "car_models.edit.placeholders.enter_description_en": "Enter description in English",
      "car_models.edit.placeholders.enter_description_fr": "Enter description in French",
      "car_models.edit.buttons.cancel": "Cancel",
      "car_models.edit.buttons.update": "Update Model",
      "car_models.edit.errors.brand_name_required": "Brand name is required",
      "car_models.edit.errors.model_name_required": "Model name is required",
      "car_models.edit.errors.transmission_type_required": "Transmission type is required",
      "car_models.edit.errors.body_type_required": "Body type is required",
      "car_models.edit.image_alt": "Model preview",

      // Clients section
      "clients.title": "Clients | Admin.Drivitive",
      "clients.description": "Manage clients",
      "clients.columns.client": "Client",
      "clients.columns.verification": "Verification",
      "clients.columns.registered": "Registered",
      "clients.columns.location": "Location",
      "clients.columns.actions": "Actions",
      "clients.filters.country": "Country",
      "clients.filters.verification_status": "Verification Status",
      "clients.filters.registration_date": "Registration Date",
      "clients.filters.status.new": "New",
      "clients.filters.status.verified": "Verified",
      "clients.filters.status.verification_needed": "Verification needed",
      "clients.filters.status.actualization_needed": "Actualization needed",
      "clients.filters.date_range": "Select date range",
      "clients.filters.sort_by_date": "Sort by Date",
      "clients.filters.reset_filters": "Reset Filters",
      "clients.details.title": "Client Details",
      "clients.details.personal_info": "Personal Information",
      "clients.details.contact_info": "Contact Information",
      "clients.details.verification_status": "Verification Status",
      "clients.details.client_rentings": "Client Rentings",
      "clients.details.full_name": "Full Name",
      "clients.details.client_type": "Client Type",
      "clients.details.language": "Language",
      "clients.details.country": "Country",
      "clients.details.city": "City",
      "clients.details.address": "Address",
      "clients.details.postal_code": "Postal Code",
      "clients.details.registered": "Registered",
      "clients.details.email": "Email",
      "clients.details.phone": "Phone",
      "clients.details.verified": "Verified",
      "clients.details.not_verified": "Not Verified",
      "clients.details.verify_client": "Verify Client",
      "clients.details.copy_email": "Copy email",
      "clients.details.view_details": "View details",
      "clients.details.error_loading": "Error loading client details",

      // Archive verification
      "clients.archive.checking_archive": "Checking archive availability...",
      "clients.archive.waiting_for_documents": "Waiting for documents archive",
      "clients.archive.checking_every_5_seconds": "Checking for new documents every 5 seconds",
      "clients.archive.documents_ready": "Documents archive is ready",
      "clients.archive.click_to_download": "Click to download and start verification process",
      "clients.archive.get_archive": "Get Archive",
      "clients.archive.archive_downloaded": "Archive downloaded successfully",
      "clients.archive.ready_to_start_review": "Ready to start document review",
      "clients.archive.start_review": "Start Review",
      "clients.archive.reviewing_documents": "Reviewing documents",
      "clients.archive.time_remaining": "Time remaining",
      "clients.archive.review_instructions.title": "Please follow these steps:",
      "clients.archive.review_instructions.step1": "Download and extract the archive",
      "clients.archive.review_instructions.step2": "Carefully review all documents (passport, driver's license, etc.)",
      "clients.archive.review_instructions.step3": "Wait for the timer to complete before making a decision",
      "clients.archive.ready_to_decide": "Review period completed",
      "clients.archive.make_decision": "Please make a decision about the verification",
      "clients.archive.accept": "Accept",
      "clients.archive.decline": "Decline",
      "clients.archive.accepting": "Accepting...",
      "clients.archive.declining": "Declining...",

      // Profile section
      "profile.title": "Profile | Admin.Drivitive",
      "profile.description": "User profile information",
      "profile.breadcrumb": "Profile",
      "profile.edit": "Edit Profile",
      "profile.fields.username": "Username",
      "profile.fields.email": "Email",
      "profile.fields.phone": "Phone",
      "profile.fields.first_name": "First Name",
      "profile.fields.last_name": "Last Name",
      "profile.fields.role": "Role",
      "profile.fields.telegram": "Telegram",
      "profile.edit.title": "Edit Profile",
      "profile.edit.description": "Update your profile information",
      "profile.edit.fields.first_name": "First Name",
      "profile.edit.fields.last_name": "Last Name",
      "profile.edit.fields.email": "Email",
      "profile.edit.fields.phone": "Phone",
      "profile.edit.fields.telegram": "Telegram",
      "profile.edit.placeholders.first_name": "Enter first name",
      "profile.edit.placeholders.last_name": "Enter last name",
      "profile.edit.placeholders.email": "Enter email",
      "profile.edit.placeholders.phone": "Enter phone number",
      "profile.edit.placeholders.telegram": "name without @ symbol",
      "profile.edit.buttons.cancel": "Cancel",
      "profile.edit.buttons.save": "Save",
      "profile.edit.buttons.saving": "Saving...",

      // Settings section
      "settings.title": "Settings | Admin.Drivitive",
      "settings.description": "User settings",
      "settings.breadcrumb": "Settings",
      "settings.language.title": "Language",
      "settings.language.description": "Select your preferred language for the interface",
      "settings.language.options.english": "English",
      "settings.language.options.french": "Français",

      // Form close confirmation
      "form.close_confirmation.title": "Unsaved Changes",
      "form.close_confirmation.message": "You have unsaved changes. Are you sure you want to close this form? All changes will be lost.",
      "form.close_confirmation.continue_editing": "Continue Editing",
      "form.close_confirmation.close_without_saving": "Close Without Saving",

      // Activities section
      "activities.title": "Activities | Admin.Drivitive",
      "activities.description": "Upcoming delivery and pickup events",
      "activities.breadcrumb": "Activities",
      "activities.create": "Create Service Activity",
      "activities.columns.type": "Event Type",
      "activities.columns.car": "Car",
      "activities.columns.datetime": "Date & Time",
      "activities.columns.address": "Address",
      "activities.columns.comment": "Comment",
      "activities.columns.report": "Report",
      "activities.columns.actions": "Actions",
      "activities.filters.event_type.all": "All Events",
      "activities.filters.event_type.delivery": "Delivery",
      "activities.filters.event_type.pickup": "Pickup",
      "activities.filters.event_type.to_service": "To Service",
      "activities.filters.event_type.from_service": "From Service",
      "activities.filters.event_type.placeholder": "Filter by Event Type",
      "activities.filters.report.all": "All Reports",
      "activities.filters.report.with": "With Report",
      "activities.filters.report.without": "Without Report",
      "activities.filters.report.placeholder": "Filter by Report",
      "activities.filters.date_range.today": "Today",
      "activities.filters.date_range.tomorrow": "Tomorrow",
      "activities.filters.date_range.week": "Week",
      "activities.filters.date_range.month": "Month",
      "activities.filters.date_range.year": "Year",
      "activities.filters.date_range.custom": "Custom",
      "activities.filters.date_range.all": "All",
      "activities.filters.reset": "Reset Filters",
      "activities.table.view_renting": "View Renting",
      "activities.table.no_comment": "No comment",
      "activities.table.view_report": "View Report",
      "activities.table.add_report": "Add Report",
      "activities.table.view_details": "View Details",
      "activities.table.open_maps": "Open in Google Maps",
      "activities.cancel.title": "Cancel Activity",
      "activities.cancel.message": "Are you sure you want to cancel this activity? This action cannot be undone.",
      "activities.cancel.keep": "No, keep it",
      "activities.cancel.confirm": "Yes, cancel it",

      // Activity form
      "activities.form.create_title": "Create Activity",
      "activities.form.create_success": "Activity created successfully",
      "activities.form.create_error": "Failed to create activity",
      "activities.form.edit_success": "Activity updated successfully",
      "activities.form.edit_error": "Failed to update activity",
      "activities.form.create_description": "* Pickup or delivery activities are automatically created when a renting is created.",
      "activities.form.edit_title": "Edit Activity",
      "activities.form.edit_description": "Edit the service activity details",
      "activities.form.fields.type": "Activity Type *",
      "activities.form.fields.car": "Car *",
      "activities.form.fields.date": "Date *",
      "activities.form.fields.time": "Time *",
      "activities.form.fields.address": "Address *",
      "activities.form.fields.comment": "Comment",
      "activities.form.fields.latitude": "Latitude",
      "activities.form.fields.longitude": "Longitude",
      "activities.form.placeholders.select_type": "Select activity type",
      "activities.form.placeholders.select_car": "Select car",
      "activities.form.placeholders.loading_cars": "Loading cars...",
      "activities.form.placeholders.search_service": "Search for a car service in Paris",
      "activities.form.placeholders.enter_comment": "Enter comment (optional)",
      "activities.form.placeholders.auto_filled": "Will be filled automatically",
      "activities.form.buttons.create": "Create Activity",
      "activities.form.buttons.update": "Update Activity",
      "activities.form.options.handoff_to_service": "Handoff to Service",
      "activities.form.options.receiving_from_service": "Receiving from Service",
      "activities.form.errors.type_required": "Activity type is required",
      "activities.form.errors.car_required": "Car is required",
      "activities.form.errors.date_required": "Date is required",
      "activities.form.errors.time_required": "Time is required",
      "activities.form.errors.address_required": "Address is required",

      // Car price edit modal
      "cars.price_edit.title.edit": "Edit",
      "cars.price_edit.title.add": "Add",
      "cars.price_edit.title.price": "Price",
      "cars.price_edit.title.for_date_range": "for Date Range",
      "cars.price_edit.title.for_date": "for {{date}}",
      "cars.price_edit.fields.from_date": "From Date",
      "cars.price_edit.fields.to_date": "To Date",
      "cars.price_edit.fields.price": "Price",
      "cars.price_edit.fields.discount": "Discount (%)",
      "cars.price_edit.fields.is_promotion": "Is Promotion",
      "cars.price_edit.fields.description": "Description",
      "cars.price_edit.placeholders.select_start_date": "Select start date",
      "cars.price_edit.placeholders.select_end_date": "Select end date",
      "cars.price_edit.placeholders.enter_price": "Enter price",
      "cars.price_edit.placeholders.enter_discount": "Enter discount percentage",
      "cars.price_edit.placeholders.enter_description": "Enter description",
      "cars.price_edit.buttons.set_until_month_end": "Set until the end of month",
      "cars.price_edit.buttons.update": "Update",
      "cars.price_edit.buttons.save": "Save",
      "cars.price_edit.errors.price_positive": "Price must be positive",
      "cars.price_edit.errors.discount_range": "Discount must be between 0 and 100",
      "cars.price_edit.errors.select_both_dates": "Please select both start and end dates",
      "cars.price_edit.errors.start_before_end": "Start date must be before or equal to end date",

      // Car reports
      "cars.report.create.title": "Create Car Report",
      "cars.report.create.description": "Fill in the car report details",
      "cars.report.edit.title": "Edit Car Report",
      "cars.report.edit.description": "Edit the car report details",
      "cars.report.edit.confirm_close": "You have unsaved changes. Are you sure you want to close the form?",
      "cars.report.fields.report_type": "Report Type",
      "cars.report.fields.mileage": "Mileage",
      "cars.report.fields.fuel_level": "Fuel Level (%)",
      "cars.report.fields.charge_level": "Charge Level (%)",
      "cars.report.fields.detail": "Detail",
      "cars.report.fields.comment": "Comment",
      "cars.report.fields.images": "Images",
      "cars.report.fields.images_to_upload": "Images to Upload",
      "cars.report.sections.car_details": "Car Details",
      "cars.report.placeholders.enter_mileage": "Enter mileage",
      "cars.report.placeholders.enter_fuel_level": "Enter fuel level",
      "cars.report.placeholders.enter_charge_level": "Enter charge level",
      "cars.report.placeholders.select_detail": "Select detail",
      "cars.report.placeholders.add_comment": "Add comments about this detail...",
      "cars.report.placeholders.before_select_detail": "Before select detail",
      "cars.report.buttons.add": "Add",
      "cars.report.buttons.create": "Create Report",
      "cars.report.buttons.creating": "Creating Report...",
      "cars.report.buttons.uploading": "Uploading Images...",
      "cars.report.buttons.save_changes": "Save Changes",
      "cars.report.buttons.saving": "Saving...",
      "cars.report.options.upon_delivering": "Upon Delivering",
      "cars.report.options.upon_picking_up": "Upon Picking Up",
      "cars.report.options.handoff_to_service": "Handoff to Service",
      "cars.report.options.receiving_from_service": "Receiving from Service",
      "cars.report.options.already_exists": "(Already exists)",
      "cars.report.errors.mileage_positive": "Mileage must be greater than 0",
      "cars.report.errors.fuel_level_max": "Fuel level cannot exceed 100%",
      "cars.report.errors.detail_required": "Detail selection is required",
      "cars.report.errors.select_all_details": "Please select a detail for all added blocks",
      "cars.report.create_success": "Car report created successfully",
      "cars.report.create_error": "Failed to create car report",
      "cars.report.edit_success": "Car report updated successfully",
      "cars.report.edit_error": "Failed to update car report",
      "cars.price_edit.save_success": "Price saved successfully",
      "cars.price_edit.save_error": "Failed to save price",
      "cars.price_edit.toggle_error": "Failed to update price visibility",
      "cars.delete.success": "Car deleted successfully",
      "cars.delete.error": "Failed to delete car",
      "rentings.datetime_edit.update_success": "Date/time updated successfully",
      "rentings.datetime_edit.update_error": "Failed to update date/time",
      "rentings.address_edit.update_success": "Address updated successfully",
      "rentings.address_edit.update_error": "Failed to update address",
      "rentings.cancel.success": "Renting cancelled successfully",
      "rentings.cancel.error": "Failed to cancel renting",
      "rentings.confirm.success": "Renting confirmed successfully",
      "rentings.confirm.error": "Failed to confirm renting",
      "rentings.comment.create_success": "Comment added successfully",
      "rentings.comment.create_error": "Failed to add comment",
      "team.edit_user.save_success": "User updated successfully",
      "team.edit_user.save_error": "Failed to update user",
      "profile.edit.save_success": "Profile updated successfully",
      "profile.edit.save_error": "Failed to update profile",
      "clients.verification.verify_success": "Client verified successfully",
      "clients.verification.verify_error": "Failed to verify client",
      "clients.verification.decline_success": "Verification declined",
      "clients.verification.decline_error": "Failed to decline verification",
      "car_models.delete.success": "Car model deleted successfully",
      "car_models.delete.error": "Failed to delete car model",
      "car_models.status_toggle.success": "Status changed successfully",
      "car_models.status_toggle.error": "Failed to change status",
      "activities.delete.success": "Activity deleted successfully",
      "activities.delete.error": "Failed to delete activity"
    }
  },
  fr: {
    translation: {
      // Navigation items
      "nav.rentings": "Locations",
      "nav.rent_calendar": "Calendrier des locations",
      "nav.cars": "Voitures",
      "nav.activities": "Activités",
      "nav.car_models": "Modèles de voitures",
      "nav.clients": "Clients",
      "nav.home": "Accueil",

      // Menu sections
      "menu.title": "Menu",
      "menu.version": "Version",
      "menu.production": "Production",
      "menu.staging": "Staging",
      "menu.site": "Site",
      "menu.piccolo": "Piccolo",

      // Settings
      "settings.menu_order.title": "Ordre du menu",
      "settings.menu_order.description": "Faites glisser et déposez les éléments du menu pour modifier leur ordre dans la barre latérale. Sur les appareils mobiles, appuyez et maintenez un élément pendant un moment pour commencer à le faire glisser. Les modifications sont enregistrées automatiquement.",

      // Filters
      "filters.columns": "Colonnes",

      // Cars section
      "cars.title": "Voitures | Admin.Drivitive",
      "cars.description": "Gérer les voitures",
      "cars.add_new": "Ajouter une voiture",
      "cars.columns.image": "Image",
      "cars.columns.info": "Informations",
      "cars.columns.color": "Couleur",
      "cars.columns.price": "Prix",
      "cars.columns.usage_stats": "Statistiques d'utilisation",
      "cars.columns.actions": "Actions",
      "cars.actions.edit": "Modifier",
      "cars.actions.details": "Détails",
      "cars.view_car_details": "Voir les détails de la voiture",
      "cars.view_model_details": "Voir les détails du modèle",
      "cars.stats.title": "Statistiques d'utilisation",
      "cars.stats.busy_days": "Jours occupés",
      "cars.stats.free_days": "Jours libres",
      "cars.stats.no_data": "Aucune donnée",
      "cars.stats.all_time": "Tout le temps",
      "cars.stats.entire_year": "Année {{year}} entière",
      "cars.stats.busy": "{{percentage}}% occupé",
      "cars.details.title": "Détails de la voiture",
      "cars.details.actions": "Actions",
      "cars.details.information": "Informations",
      "cars.details.english_description": "Description en anglais",
      "cars.details.french_description": "Description en français",
      "cars.details.delete.title": "Supprimer la voiture",
      "cars.details.delete.confirmation": "Êtes-vous sûr de vouloir supprimer cette voiture ? Cette action ne peut pas être annulée.",
      "cars.details.delete.button": "Supprimer",
      "cars.details.delete.cancel": "Annuler",
      "cars.details.delete.deleting": "Suppression...",
      "cars.details.edit.button": "Modifier la voiture",
      "cars.details.fields.year": "Année",
      "cars.details.fields.reg_number": "№",
      "cars.details.fields.color": "Couleur",
      "cars.details.fields.fuel_type": "Type de carburant",
      "cars.details.fields.fuel_consumption": "Consommation de carburant",
      "cars.details.fields.engine": "Moteur",
      "cars.details.fields.seats": "Places",
      "cars.details.fields.doors": "Portes",
      "cars.details.fields.drivetrain": "Transmission",
      "cars.details.fields.clearance": "Garde au sol",
      "cars.details.fields.price_per_day": "Prix par jour",
      "cars.details.fields.mileage_limit": "Lim. km",
      "cars.details.fields.features": "Caractéristiques",
      "cars.details.errors.loading": "Chargement...",
      "cars.details.errors.error_loading": "Erreur lors du chargement des détails de la voiture",
      "cars.details.errors.model_not_found": "Erreur : Informations sur le modèle de voiture non trouvées",

      // Rentings section
      "rentings.title": "Locations | Admin.Drivitive",
      "rentings.description": "Liste des locations",
      "rentings.breadcrumb": "Locations",
      "rentings.breadcrumb.renting": "Location",
      "rentings.columns.id": "ID de location",
      "rentings.columns.car": "Voiture",
      "rentings.columns.delivery": "Livraison",
      "rentings.columns.status": "Statut",
      "rentings.columns.client": "Client",
      "rentings.columns.price": "Prix total",
      "rentings.columns.comments": "Commentaires",
      "rentings.columns.reports": "Rapports",
      "rentings.columns.actions": "Actions",
      "rentings.columns.reports.delivery": "Livraison",
      "rentings.columns.reports.pickup": "Prise en charge",
      "rentings.filters.status.all": "Tous les statuts",
      "rentings.filters.status.draft": "Brouillon",
      "rentings.filters.status.confirmed": "Confirmée",
      "rentings.filters.status.finished": "Terminée",
      "rentings.filters.status.cancelled": "Annulée",
      "rentings.filters.car.all": "Toutes les voitures",
      "rentings.filters.status.placeholder": "Filtrer par statut",
      "rentings.filters.car.placeholder": "Filtrer par voiture",
      "rentings.filters.loading_cars": "Chargement des voitures...",
      "rentings.filters.reset": "Réinitialiser les filtres",
      "rentings.calendar.title": "Calendrier des locations",
      "rentings.calendar.description": "Calendrier des locations",

      // Renting comment form
      "rentings.comment.title": "Ajouter un commentaire",
      "rentings.comment.description": "Ajouter un commentaire à cette location",
      "rentings.comment.fields.comment": "Commentaire",
      "rentings.comment.fields.image": "Image (optionnel)",
      "rentings.comment.placeholders.enter_comment": "Entrez votre commentaire...",
      "rentings.comment.buttons.add": "Ajouter le commentaire",
      "rentings.comment.buttons.adding": "Ajout du commentaire...",
      "rentings.comment.errors.text_required": "Le texte du commentaire est requis",
      "rentings.comment.errors.create_failed": "Échec de la création du commentaire. Veuillez réessayer.",

      // Renting edit form
      "rentings.edit.title": "Modifier la location",
      "rentings.edit.success": "Location mise à jour avec succès",
      "rentings.edit.error": "Échec de la mise à jour de la location",
      "rentings.edit.description": "Mettre à jour les informations de la location",
      "rentings.edit.fields.client": "Client",
      "rentings.edit.fields.car": "Voiture",
      "rentings.edit.fields.start_date": "Date de début",
      "rentings.edit.fields.start_time": "Heure de début",
      "rentings.edit.fields.end_date": "Date de fin",
      "rentings.edit.fields.end_time": "Heure de fin",
      "rentings.edit.fields.delivery_address": "Adresse de livraison",
      "rentings.edit.fields.pickup_address": "Adresse de récupération",
      "rentings.edit.fields.delivery_latitude": "Latitude de livraison",
      "rentings.edit.fields.delivery_longitude": "Longitude de livraison",
      "rentings.edit.fields.pickup_latitude": "Latitude de récupération",
      "rentings.edit.fields.pickup_longitude": "Longitude de récupération",
      "rentings.edit.fields.total_price": "Prix total",
      "rentings.edit.fields.original_price": "Prix original",
      "rentings.edit.fields.currency": "Devise",
      "rentings.edit.placeholders.select_date": "Sélectionner la date",
      "rentings.edit.placeholders.enter_delivery_address": "Entrer l'adresse de livraison",
      "rentings.edit.placeholders.enter_pickup_address": "Entrer l'adresse de récupération",
      "rentings.edit.placeholders.enter_latitude": "Entrer la latitude",
      "rentings.edit.placeholders.enter_longitude": "Entrer la longitude",
      "rentings.edit.placeholders.enter_total_price": "Entrer le prix total",
      "rentings.edit.placeholders.enter_original_price": "Entrer le prix original",
      "rentings.edit.buttons.update": "Mettre à jour la location",
      "rentings.edit.buttons.updating": "Mise à jour...",
      "rentings.edit.errors.start_date_required": "La date de début est requise",
      "rentings.edit.errors.start_time_required": "L'heure de début est requise",
      "rentings.edit.errors.end_date_required": "La date de fin est requise",
      "rentings.edit.errors.end_time_required": "L'heure de fin est requise",
      "rentings.edit.errors.delivery_address_required": "L'adresse de livraison est requise",
      "rentings.edit.errors.pickup_address_required": "L'adresse de récupération est requise",
      "rentings.edit.errors.total_price_required": "Le prix total est requis",
      "rentings.edit.errors.currency_required": "La devise est requise",
      "rentings.edit.errors.end_after_start_required": "La date/heure de fin doit être après la date/heure de début",
      "rentings.edit.errors.update_failed": "Échec de la mise à jour de la location. Veuillez réessayer.",

      // Renting date/time edit
      "rentings.datetime_edit.title.edit_start_datetime": "Modifier la date et l'heure de début",
      "rentings.datetime_edit.title.edit_end_datetime": "Modifier la date et l'heure de fin",
      "rentings.datetime_edit.description": "Mettre à jour la date et l'heure pour cette location",
      "rentings.datetime_edit.fields.date": "Date",
      "rentings.datetime_edit.fields.time": "Heure",
      "rentings.datetime_edit.buttons.update": "Mettre à jour",
      "rentings.datetime_edit.buttons.updating": "Mise à jour...",
      "rentings.datetime_edit.errors.date_required": "La date est requise",
      "rentings.datetime_edit.errors.time_required": "L'heure est requise",
      "rentings.datetime_edit.errors.future_datetime_required": "La date et l'heure doivent être dans le futur",
      "rentings.datetime_edit.errors.update_failed": "Échec de la mise à jour de la date/heure. Veuillez réessayer.",
      "rentings.datetime_edit.edit_start_datetime": "Modifier la date/heure de début",
      "rentings.datetime_edit.edit_end_datetime": "Modifier la date/heure de fin",

      // Renting address edit
      "rentings.address_edit.title.edit_delivery_address": "Modifier l'adresse de livraison",
      "rentings.address_edit.title.edit_pickup_address": "Modifier l'adresse de récupération",
      "rentings.address_edit.description": "Mettre à jour l'adresse et les coordonnées pour cet emplacement",
      "rentings.address_edit.fields.address": "Adresse",
      "rentings.address_edit.fields.latitude": "Latitude",
      "rentings.address_edit.fields.longitude": "Longitude",
      "rentings.address_edit.placeholders.enter_address": "Entrer l'adresse",
      "rentings.address_edit.placeholders.enter_latitude": "Entrer la latitude",
      "rentings.address_edit.placeholders.enter_longitude": "Entrer la longitude",
      "rentings.address_edit.buttons.update": "Mettre à jour",
      "rentings.address_edit.buttons.updating": "Mise à jour...",
      "rentings.address_edit.errors.address_required": "L'adresse est requise",
      "rentings.address_edit.errors.latitude_required": "La latitude est requise",
      "rentings.address_edit.errors.longitude_required": "La longitude est requise",
      "rentings.address_edit.errors.latitude_invalid": "La latitude doit être comprise entre -90 et 90",
      "rentings.address_edit.errors.longitude_invalid": "La longitude doit être comprise entre -180 et 180",
      "rentings.address_edit.errors.update_failed": "Échec de la mise à jour de l'adresse. Veuillez réessayer.",
      "rentings.address_edit.edit_delivery_address": "Modifier l'adresse de livraison",
      "rentings.address_edit.edit_pickup_address": "Modifier l'adresse de récupération",

      // Pagination
      "pagination.previous": "Précédent",
      "pagination.next": "Suivant",
      "pagination.ellipsis": "...",

      // Common translations
      "Loading...": "Chargement...",
      "Error": "Erreur",
      "Confirm": "Confirmer",
      "Cancel": "Annuler",
      "Save": "Enregistrer",
      "Edit": "Modifier",
      "Delete": "Supprimer",
      "Close": "Fermer",
      "Yes": "Oui",
      "No": "Non",
      "Back": "Retour",
      "Next": "Suivant",
      "Search": "Rechercher",
      "Filter": "Filtrer",
      "All": "Tout",
      "None": "Aucun",
      "Details": "Détails",
      "Actions": "Actions",
      "Status": "Statut",
      "Date": "Date",
      "Time": "Heure",
      "Price": "Prix",
      "Total": "Total",
      "Original": "Original",
      "per day": "par jour",
      "Period": "Période",
      "Client": "Client",
      "Contact info": "Informations de contact",
      "Created": "Créé",
      "View details": "Voir les détails",
      "Color": "Couleur",
      "Year": "Année",
      "Reg. number": "N° d'immatriculation",
      "No comments": "Aucun commentaire",
      "No extra services": "Aucun service supplémentaire",
      "Add comment": "Ajouter un commentaire",
      "Confirming...": "Confirmation en cours...",
      "Canceling...": "Annulation en cours...",
      "Yes, confirm it": "Oui, confirmer",
      "No, cancel": "Non, annuler",
      "No, keep it": "Non, conserver",
      "Yes, cancel it": "Oui, annuler",
      "Edit Renting": "Modifier la location",
      "This action cannot be undone.": "Cette action ne peut pas être annulée.",
      "common.buttons.cancel": "Annuler",

      // Renting details page
      "Renting details": "Détails de la location",
      "Rental Details": "Détails de la location",
      "Delivery Details": "Détails de livraison",
      "Car": "Voiture",
      "Extra Services": "Services supplémentaires",
      "Comments": "Commentaires",
      "Confirm Renting": "Confirmer la location",
      "Cancel Renting": "Annuler la location",
      "Are you sure you want to confirm this renting?": "Êtes-vous sûr de vouloir confirmer cette location ?",
      "Are you sure you want to cancel this renting?": "Êtes-vous sûr de vouloir annuler cette location ?",
      "Delivery Address": "Adresse de livraison",
      "Pickup Address": "Adresse de récupération",
      "Total price": "Prix total",
      "Renting": "Location",
      "Error loading renting details": "Erreur lors du chargement des détails de la location",

      // Car Reports translations
      "Car Reports": "Rapports de voiture",
      "Delivery Report": "Rapport de livraison",
      "Pickup Report": "Rapport de prise en charge",
      "Create Report": "Créer un rapport",
      "Mileage": "Kilométrage",
      "Fuel Level": "Niveau de carburant",
      "No reports available": "Aucun rapport disponible",
      "Failed to load reports": "Échec du chargement des rapports",

      // Report Details Page
      "reports.details.title": "Rapport",
      "reports.details.description": "Détails du rapport",
      "reports.details.error_loading": "Erreur lors du chargement des détails du rapport",
      "reports.details.report_details": "Détails du rapport",
      "reports.details.edit_report": "Modifier le rapport",
      "reports.details.report_type": "Type de rapport",
      "reports.details.delivery_report": "Rapport de livraison",
      "reports.details.pickup_report": "Rapport de reprise",
      "reports.details.for_renting": "pour la location",
      "reports.details.created_at": "Créé le",
      "reports.details.employee": "Employé",
      "reports.details.mileage": "Kilométrage",
      "reports.details.fuel_level": "Niveau de carburant",
      "reports.details.charge_level": "Niveau de charge",
      "reports.details.renting_details": "Détails de la location",
      "reports.details.client": "Client",
      "reports.details.period": "Période",
      "reports.details.delivery_address": "Adresse de livraison",
      "reports.details.pickup_address": "Adresse de reprise",
      "reports.details.car": "Voiture",
      "reports.details.view_car_details": "Voir les détails de la voiture",
      "reports.details.year": "Année",
      "reports.details.reg_number": "N° d'immatriculation",
      "reports.details.car_details": "Détails de la voiture",
      "reports.details.detail": "Détail",
      "reports.details.image": "image",
      "reports.details.print": "Imprimer",

      // Date Range Filter Modal
      "date_range_filter.title": "Sélectionner la période",
      "date_range_filter.year": "Année",
      "date_range_filter.quarter": "Trimestre",
      "date_range_filter.month": "Mois",
      "date_range_filter.select_year_first": "Sélectionner l'année d'abord",
      "date_range_filter.select_quarter_first": "Sélectionner le trimestre d'abord",
      "date_range_filter.select_year_quarter_first": "Sélectionner l'année et le trimestre d'abord",
      "date_range_filter.start_date": "Date de début",
      "date_range_filter.end_date": "Date de fin",
      "date_range_filter.apply": "Appliquer",

      // Car creation form
      "cars.create.title": "Ajouter une nouvelle voiture",
      "cars.create.success": "Voiture créée avec succès",
      "cars.create.error": "Échec de la création de la voiture",
      "cars.edit.title": "Modifier la voiture",
      "cars.edit.success": "Voiture mise à jour avec succès",
      "cars.edit.error": "Échec de la mise à jour de la voiture",
      "cars.create.subtitle": "Créer une nouvelle voiture",
      "cars.edit.subtitle": "Mettre à jour la voiture",
      "cars.create.basic_info": "Informations de base",
      "cars.create.technical_specs": "Spécifications techniques",
      "cars.create.descriptions": "Descriptions",
      "cars.create.permitted_area": "Zone autorisée",
      "cars.create.interior_features": "Intérieur et caractéristiques",
      "cars.create.fields.car_image": "Image de la voiture",
      "cars.create.fields.car_model": "Modèle",
      "cars.create.fields.reg_number": "№",
      "cars.create.fields.slug": "Slug",
      "cars.create.fields.color": "Couleur",
      "cars.create.fields.release_year": "Année de sortie",
      "cars.create.fields.price": "Prix",
      "cars.create.fields.fuel_type": "Type de carburant",
      "cars.create.fields.drivetrain": "Transmission",
      "cars.create.fields.engine_displacement": "Cylindrée (L)",
      "cars.create.fields.engine_power": "Puissance moteur (ch)",
      "cars.create.fields.fuel_consumption": "Consommation (L/100km)",
      "cars.create.fields.ecology_class": "Classe écologique",
      "cars.create.fields.english": "Anglais",
      "cars.create.fields.french": "Français",
      "cars.create.fields.gps": "Navigation GPS",
      "cars.create.fields.latitude": "Latitude",
      "cars.create.fields.longitude": "Longitude",
      "cars.create.fields.radius": "Rayon (km)",
      "cars.create.fields.seats": "Places",
      "cars.create.fields.doors": "Portes",
      "cars.create.fields.clearance": "Garde au sol",
      "cars.create.fields.mileage_limit": "Limite",
      "cars.create.placeholders.select_model": "Sélectionner le modèle",
      "cars.create.placeholders.enter_reg_number": "Entrer le numéro d'immatriculation",
      "cars.create.placeholders.enter_slug": "Entrer le slug",
      "cars.create.placeholders.select_color": "Sélectionner la couleur",
      "cars.create.placeholders.enter_year": "Entrer l'année de sortie",
      "cars.create.placeholders.enter_price": "Entrer le prix",
      "cars.create.placeholders.select_fuel_type": "Sélectionner le type de carburant",
      "cars.create.placeholders.select_drivetrain": "Sélectionner la transmission",
      "cars.create.placeholders.enter_engine": "ex. 2.0",
      "cars.create.placeholders.enter_power": "ex. 150",
      "cars.create.placeholders.enter_consumption": "ex. 7.5",
      "cars.create.placeholders.enter_ecology": "ex. Euro 6",
      "cars.create.placeholders.enter_description_en": "Entrer la description en anglais",
      "cars.create.placeholders.enter_description_fr": "Entrer la description en français",
      "cars.create.placeholders.enter_latitude": "Entrer la latitude",
      "cars.create.placeholders.enter_longitude": "Entrer la longitude",
      "cars.create.placeholders.enter_radius": "Entrer le rayon",
      "cars.create.placeholders.enter_seats": "Nombre",
      "cars.create.placeholders.enter_doors": "Nombre",
      "cars.create.placeholders.enter_clearance": "Hauteur",
      "cars.create.placeholders.enter_mileage": "Par jour",
      "cars.create.buttons.cancel": "Annuler",
      "cars.create.buttons.create": "Créer la voiture",
      "cars.edit.buttons.update": "Mettre la voiture",
      "cars.create.errors.model_required": "Le modèle de voiture est requis",
      "cars.create.errors.reg_number_required": "Le numéro d'immatriculation est requis",
      "cars.create.errors.color_required": "La couleur est requise",
      "cars.create.errors.price_required": "Un prix valide est requis",
      "cars.create.errors.fuel_type_required": "Veuillez sélectionner un type de carburant",
      "cars.create.errors.drivetrain_required": "Veuillez sélectionner une transmission",
      "cars.price_calendar.title": "Calendrier des prix",
      "cars.price_calendar.add_range_price": "Ajouter un prix",
      "cars.price_calendar.custom_price": "Prix personnalisé",
      "cars.price_calendar.discount": "Remise",
      "cars.price_calendar.promotion": "Promotion",

      // Header translations
      "header.stage_badge": "Admin Staging",
      "header.toggle_sidebar": "Basculer la barre latérale",
      "header.go_back": "Retour",
      "header.app_name": "Admin.Drivitive",
      "header.search_placeholder": "Rechercher ou taper une commande...",
      "header.search_shortcut": "⌘ K",

      // User dropdown translations
      "user_dropdown.profile": "Profil",
      "user_dropdown.settings": "Réglages",
      "user_dropdown.sign_out": "Quitter",
      "user_dropdown.account_settings": "Paramètres du compte",
      "user_dropdown.support": "Support",
      "user_dropdown.team": "Équipe",

      // Team section
      "team.title": "Équipe | Admin.Drivitive",
      "team.description": "Gérer les administrateurs de l'équipe",
      "team.columns.name": "Nom",
      "team.columns.email": "Email",
      "team.columns.role": "Rôle",
      "team.columns.actions": "Actions",
      "team.actions.edit": "Modifier",
      "team.role.admin": "Admin",
      "team.role.seo": "SEO",
      "team.edit_user.title": "Modifier l'utilisateur",
      "team.edit_user.name": "Nom",
      "team.edit_user.email": "Email",
      "team.edit_user.role": "Rôle",
      "team.edit_user.save": "Enregistrer",
      "team.edit_user.cancel": "Annuler",

      // Car Models section
      "car_models.title": "Modèles de voitures | Admin.Drivitive",
      "car_models.description": "Gérer les modèles de voitures",
      "car_models.add_new": "Ajouter un modèle",
      "car_models.columns.image": "Image",
      "car_models.columns.model": "Modèle",
      "car_models.columns.status": "Statut",
      "car_models.columns.description": "Description",
      "car_models.columns.actions": "Actions",
      "car_models.actions.details": "Détails",
      "car_models.status.active": "Actif",
      "car_models.status.inactive": "Inactif",
      "car_models.description.english": "🇺🇸 Anglais :",
      "car_models.description.french": "🇫🇷 Français :",
      "car_models.details.title": "Détails du modèle",
      "car_models.details.about": "À propos du modèle",
      "car_models.details.edit": "Modifier le modèle",
      "car_models.details.activate": "Activer",
      "car_models.details.deactivate": "Désactiver",
      "car_models.details.delete": "Supprimer",
      "car_models.details.slug": "Slug :",
      "car_models.details.body_type": "Type de carrosserie",
      "car_models.details.transmission": "Transmission",
      "car_models.details.english_description": "🇺🇸 Description en anglais",
      "car_models.details.french_description": "🇫🇷 Description en français",
      "car_models.details.no_description": "Aucune description disponible",

      // Car Model Creation Form
      "car_models.create.title": "Créer un modèle de voiture",
      "car_models.create.success": "Modèle de voiture créé avec succès",
      "car_models.create.error": "Échec de la création du modèle de voiture",
      "car_models.create.description": "Ajouter un nouveau modèle de voiture",
      "car_models.create.fields.image": "Image du modèle",
      "car_models.create.fields.slug": "Slug",
      "car_models.create.fields.brand_name": "Marque",
      "car_models.create.fields.model_name": "Nom du modèle",
      "car_models.create.fields.transmission_type": "Type de transmission",
      "car_models.create.fields.body_type": "Type de carrosserie",
      "car_models.create.fields.description_en": "Description en anglais",
      "car_models.create.fields.description_fr": "Description en français",
      "car_models.create.placeholders.enter_slug": "Entrer le slug ou il sera généré automatiquement",
      "car_models.create.placeholders.enter_brand_name": "Entrer le nom de la marque",
      "car_models.create.placeholders.enter_model_name": "Entrer le nom du modèle",
      "car_models.create.placeholders.select_transmission": "Sélectionner le type de transmission",
      "car_models.create.placeholders.select_body_type": "Sélectionner le type de carrosserie",
      "car_models.create.placeholders.enter_description_en": "Entrer la description en anglais",
      "car_models.create.placeholders.enter_description_fr": "Entrer la description en français",
      "car_models.create.buttons.create": "Créer le modèle",
      "car_models.create.errors.brand_name_required": "Le nom de la marque est requis",
      "car_models.create.errors.model_name_required": "Le nom du modèle est requis",
      "car_models.create.errors.transmission_type_required": "Le type de transmission est requis",
      "car_models.create.errors.body_type_required": "Le type de carrosserie est requis",
      "car_models.create.image_alt": "Aperçu du modèle",

      // Car Model Edit Form
      "car_models.edit.title": "Modifier le modèle de voiture",
      "car_models.edit.success": "Modèle de voiture mis à jour avec succès",
      "car_models.edit.error": "Échec de la mise à jour du modèle de voiture",
      "car_models.edit.description": "Mettre à jour les détails du modèle",
      "car_models.edit.fields.image": "Image du modèle",
      "car_models.edit.fields.slug": "Slug",
      "car_models.edit.fields.brand_name": "Marque",
      "car_models.edit.fields.model_name": "Nom du modèle",
      "car_models.edit.fields.transmission_type": "Type de transmission",
      "car_models.edit.fields.body_type": "Type de carrosserie",
      "car_models.edit.fields.description_en": "Description en anglais",
      "car_models.edit.fields.description_fr": "Description en français",
      "car_models.edit.placeholders.enter_slug": "Entrer le slug ou il sera généré automatiquement",
      "car_models.edit.placeholders.enter_brand_name": "Entrer le nom de la marque",
      "car_models.edit.placeholders.enter_model_name": "Entrer le nom du modèle",
      "car_models.edit.placeholders.select_transmission": "Sélectionner le type de transmission",
      "car_models.edit.placeholders.select_body_type": "Sélectionner le type de carrosserie",
      "car_models.edit.placeholders.enter_description_en": "Entrer la description en anglais",
      "car_models.edit.placeholders.enter_description_fr": "Entrer la description en français",
      "car_models.edit.buttons.cancel": "Annuler",
      "car_models.edit.buttons.update": "Mettre à jour le modèle",
      "car_models.edit.errors.brand_name_required": "Le nom de la marque est requis",
      "car_models.edit.errors.model_name_required": "Le nom du modèle est requis",
      "car_models.edit.errors.transmission_type_required": "Le type de transmission est requis",
      "car_models.edit.errors.body_type_required": "Le type de carrosserie est requis",
      "car_models.edit.image_alt": "Aperçu du modèle",

      // Clients section
      "clients.title": "Clients | Admin.Drivitive",
      "clients.description": "Gérer les clients",
      "clients.columns.client": "Client",
      "clients.columns.verification": "Vérification",
      "clients.columns.registered": "Inscrit",
      "clients.columns.location": "Localisation",
      "clients.columns.actions": "Actions",
      "clients.filters.country": "Pays",
      "clients.filters.verification_status": "Statut de vérification",
      "clients.filters.registration_date": "Date d'inscription",
      "clients.filters.status.new": "Nouveau",
      "clients.filters.status.verified": "Vérifié",
      "clients.filters.status.verification_needed": "Vérification nécessaire",
      "clients.filters.status.actualization_needed": "Actualisation nécessaire",
      "clients.filters.date_range": "Sélectionner une période",
      "clients.filters.sort_by_date": "Trier par date",
      "clients.filters.reset_filters": "Effacer",
      "clients.details.title": "Détails du client",
      "clients.details.personal_info": "Informations personnelles",
      "clients.details.contact_info": "Informations de contact",
      "clients.details.verification_status": "Statut de vérification",
      "clients.details.client_rentings": "Locations du client",
      "clients.details.full_name": "Nom complet",
      "clients.details.client_type": "Type de client",
      "clients.details.language": "Langue",
      "clients.details.country": "Pays",
      "clients.details.city": "Ville",
      "clients.details.address": "Adresse",
      "clients.details.postal_code": "Code postal",
      "clients.details.registered": "Inscrit",
      "clients.details.email": "Email",
      "clients.details.phone": "Téléphone",
      "clients.details.verified": "Vérifié",
      "clients.details.not_verified": "Non vérifié",
      "clients.details.verify_client": "Vérifier le client",
      "clients.details.copy_email": "Copier l'email",
      "clients.details.view_details": "Voir les détails",
      "clients.details.error_loading": "Erreur lors du chargement des détails du client",

      // Archive verification
      "clients.archive.checking_archive": "Vérification de la disponibilité de l'archive...",
      "clients.archive.waiting_for_documents": "En attente de l'archive des documents",
      "clients.archive.checking_every_5_seconds": "Vérification des nouveaux documents toutes les 5 secondes",
      "clients.archive.documents_ready": "L'archive des documents est prête",
      "clients.archive.click_to_download": "Cliquez pour télécharger et commencer le processus de vérification",
      "clients.archive.get_archive": "Obtenir l'Archive",
      "clients.archive.archive_downloaded": "Archive téléchargée avec succès",
      "clients.archive.ready_to_start_review": "Prêt à commencer l'examen des documents",
      "clients.archive.start_review": "Commencer l'Examen",
      "clients.archive.reviewing_documents": "Examen des documents en cours",
      "clients.archive.time_remaining": "Temps restant",
      "clients.archive.review_instructions.title": "Veuillez suivre ces étapes :",
      "clients.archive.review_instructions.step1": "Téléchargez et extrayez l'archive",
      "clients.archive.review_instructions.step2": "Examinez attentivement tous les documents (passeport, permis de conduire, etc.)",
      "clients.archive.review_instructions.step3": "Attendez que le minuteur se termine avant de prendre une décision",
      "clients.archive.ready_to_decide": "Période d'examen terminée",
      "clients.archive.make_decision": "Veuillez prendre une décision concernant la vérification",
      "clients.archive.accept": "Accepter",
      "clients.archive.decline": "Refuser",
      "clients.archive.accepting": "Acceptation...",
      "clients.archive.declining": "Refus...",

      // Profile section
      "profile.title": "Profil | Admin.Drivitive",
      "profile.description": "Informations du profil utilisateur",
      "profile.breadcrumb": "Profil",
      "profile.edit": "Modifier le profil",
      "profile.fields.username": "Nom d'utilisateur",
      "profile.fields.email": "Email",
      "profile.fields.phone": "Téléphone",
      "profile.fields.first_name": "Prénom",
      "profile.fields.last_name": "Nom",
      "profile.fields.role": "Rôle",
      "profile.fields.telegram": "Telegram",
      "profile.edit.title": "Modifier le profil",
      "profile.edit.description": "Mettre à jour vos informations de profil",
      "profile.edit.fields.first_name": "Prénom",
      "profile.edit.fields.last_name": "Nom",
      "profile.edit.fields.email": "Email",
      "profile.edit.fields.phone": "Téléphone",
      "profile.edit.fields.telegram": "Telegram",
      "profile.edit.placeholders.first_name": "Entrer le prénom",
      "profile.edit.placeholders.last_name": "Entrer le nom",
      "profile.edit.placeholders.email": "Entrer l'email",
      "profile.edit.placeholders.phone": "Entrer le numéro de téléphone",
      "profile.edit.placeholders.telegram": "nom sans le symbole @",
      "profile.edit.buttons.cancel": "Annuler",
      "profile.edit.buttons.save": "Enregistrer",
      "profile.edit.buttons.saving": "Enregistrement...",

      // Settings section
      "settings.title": "Paramètres | Admin.Drivitive",
      "settings.description": "Paramètres utilisateur",
      "settings.breadcrumb": "Paramètres",
      "settings.language.title": "Langue",
      "settings.language.description": "Sélectionnez votre langue préférée pour l'interface",
      "settings.language.options.english": "Anglais",
      "settings.language.options.french": "Français",

      // Form close confirmation
      "form.close_confirmation.title": "Modifications non enregistrées",
      "form.close_confirmation.message": "Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir fermer ce formulaire ? Toutes les modifications seront perdues.",
      "form.close_confirmation.continue_editing": "Continuer l'édition",
      "form.close_confirmation.close_without_saving": "Fermer sans enregistrer",

      // Activities section
      "activities.title": "Activités | Admin.Drivitive",
      "activities.description": "Prochains événements de livraison et de récupération",
      "activities.breadcrumb": "Activités",
      "activities.create": "Créer une activité de service",
      "activities.columns.type": "Type d'événement",
      "activities.columns.car": "Voiture",
      "activities.columns.datetime": "Date et heure",
      "activities.columns.address": "Adresse",
      "activities.columns.comment": "Commentaire",
      "activities.columns.report": "Rapport",
      "activities.columns.actions": "Actions",
      "activities.filters.event_type.all": "Tous les événements",
      "activities.filters.event_type.delivery": "Livraison",
      "activities.filters.event_type.pickup": "Reprise",
      "activities.filters.event_type.to_service": "Vers le service",
      "activities.filters.event_type.from_service": "Du service",
      "activities.filters.event_type.placeholder": "Filtrer par type d'événement",
      "activities.filters.report.all": "Tous les rapports",
      "activities.filters.report.with": "Avec rapport",
      "activities.filters.report.without": "Sans rapport",
      "activities.filters.report.placeholder": "Filtrer par rapport",
      "activities.filters.date_range.today": "Aujourd'hui",
      "activities.filters.date_range.tomorrow": "Demain",
      "activities.filters.date_range.week": "Semaine",
      "activities.filters.date_range.month": "Mois",
      "activities.filters.date_range.year": "Année",
      "activities.filters.date_range.custom": "Perso",
      "activities.filters.date_range.all": "Tout",
      "activities.filters.reset": "Réinitialiser les filtres",
      "activities.table.view_renting": "Voir location",
      "activities.table.no_comment": "Pas de commentaire",
      "activities.table.view_report": "Voir rapport",
      "activities.table.add_report": "Ajouter rapport",
      "activities.table.view_details": "Voir détails",
      "activities.table.open_maps": "Ouvrir dans Google Maps",
      "activities.cancel.title": "Annuler l'activité",
      "activities.cancel.message": "Êtes-vous sûr de vouloir annuler cette activité ? Cette action ne peut pas être annulée.",
      "activities.cancel.keep": "Non, conserver",
      "activities.cancel.confirm": "Oui, annuler",

      // Activity form
      "activities.form.create_title": "Créer une activité",
      "activities.form.create_success": "Activité créée avec succès",
      "activities.form.create_error": "Échec de la création de l'activité",
      "activities.form.edit_success": "Activité mise à jour avec succès",
      "activities.form.edit_error": "Échec de la mise à jour de l'activité",
      "activities.form.create_description": "* Les activités de reprise ou de livraison sont automatiquement créées lors de la création d'une location.",
      "activities.form.edit_title": "Modifier une activité",
      "activities.form.edit_description": "Modifier les détails de l'activité",
      "activities.form.description": "* Les activités de reprise ou de livraison sont automatiquement créées lors de la création d'une location.",
      "activities.form.fields.type": "Type d'activité *",
      "activities.form.fields.car": "Voiture *",
      "activities.form.fields.date": "Date *",
      "activities.form.fields.time": "Heure *",
      "activities.form.fields.address": "Adresse *",
      "activities.form.fields.comment": "Commentaire",
      "activities.form.fields.latitude": "Latitude",
      "activities.form.fields.longitude": "Longitude",
      "activities.form.placeholders.select_type": "Sélectionner le type d'activité",
      "activities.form.placeholders.select_car": "Sélectionner la voiture",
      "activities.form.placeholders.loading_cars": "Chargement des voitures...",
      "activities.form.placeholders.search_service": "Rechercher un service automobile à Paris",
      "activities.form.placeholders.enter_comment": "Entrer un commentaire (optionnel)",
      "activities.form.placeholders.auto_filled": "Sera rempli automatiquement",
      "activities.form.buttons.create": "Créer l'activité",
      "activities.form.buttons.update": "Mettre à jour l'activité",
      "activities.form.options.handoff_to_service": "Remise au service",
      "activities.form.options.receiving_from_service": "Réception du service",
      "activities.form.errors.type_required": "Le type d'activité est requis",
      "activities.form.errors.car_required": "La voiture est requise",
      "activities.form.errors.date_required": "La date est requise",
      "activities.form.errors.time_required": "L'heure est requise",
      "activities.form.errors.address_required": "L'adresse est requise",

      // Car price edit modal
      "cars.price_edit.title.edit": "Modifier",
      "cars.price_edit.title.add": "Ajouter",
      "cars.price_edit.title.price": "Prix",
      "cars.price_edit.title.for_date_range": "pour une période",
      "cars.price_edit.title.for_date": "pour le {{date}}",
      "cars.price_edit.fields.from_date": "Date de début",
      "cars.price_edit.fields.to_date": "Date de fin",
      "cars.price_edit.fields.price": "Prix",
      "cars.price_edit.fields.discount": "Remise (%)",
      "cars.price_edit.fields.is_promotion": "Est une promotion",
      "cars.price_edit.fields.description": "Description",
      "cars.price_edit.placeholders.select_start_date": "Sélectionner la date de début",
      "cars.price_edit.placeholders.select_end_date": "Sélectionner la date de fin",
      "cars.price_edit.placeholders.enter_price": "Entrer le prix",
      "cars.price_edit.placeholders.enter_discount": "Entrer le pourcentage de remise",
      "cars.price_edit.placeholders.enter_description": "Entrer la description",
      "cars.price_edit.buttons.set_until_month_end": "Définir jusqu'à la fin du mois",
      "cars.price_edit.buttons.update": "Mettre à jour",
      "cars.price_edit.buttons.save": "Enregistrer",
      "cars.price_edit.errors.price_positive": "Le prix doit être positif",
      "cars.price_edit.errors.discount_range": "La remise doit être comprise entre 0 et 100",
      "cars.price_edit.errors.select_both_dates": "Veuillez sélectionner les dates de début et de fin",
      "cars.price_edit.errors.start_before_end": "La date de début doit être antérieure ou égale à la date de fin",

      // Car reports
      "cars.report.create.title": "Créer un rapport de voiture",
      "cars.report.create.description": "Remplissez les détails du rapport de voiture",
      "cars.report.edit.title": "Modifier le rapport de voiture",
      "cars.report.edit.description": "Modifier les détails du rapport de voiture",
      "cars.report.edit.confirm_close": "Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir fermer le formulaire ?",
      "cars.report.fields.report_type": "Type de rapport",
      "cars.report.fields.mileage": "Kilométrage",
      "cars.report.fields.fuel_level": "Niveau de carburant (%)",
      "cars.report.fields.charge_level": "Niveau de charge (%)",
      "cars.report.fields.detail": "Détail",
      "cars.report.fields.comment": "Commentaire",
      "cars.report.fields.images": "Images",
      "cars.report.fields.images_to_upload": "Images à télécharger",
      "cars.report.sections.car_details": "Détails de la voiture",
      "cars.report.placeholders.enter_mileage": "Entrer le kilométrage",
      "cars.report.placeholders.enter_fuel_level": "Entrer le niveau de carburant",
      "cars.report.placeholders.enter_charge_level": "Entrer le niveau de charge",
      "cars.report.placeholders.select_detail": "Sélectionner le détail",
      "cars.report.placeholders.add_comment": "Ajouter des commentaires sur ce détail...",
      "cars.report.placeholders.before_select_detail": "Avant de sélectionner le détail",
      "cars.report.buttons.add": "Ajouter",
      "cars.report.buttons.create": "Créer le rapport",
      "cars.report.buttons.creating": "Création du rapport...",
      "cars.report.buttons.uploading": "Téléchargement des images...",
      "cars.report.buttons.save_changes": "Enregistrer les modifications",
      "cars.report.buttons.saving": "Enregistrement...",
      "cars.report.options.upon_delivering": "Lors de la livraison",
      "cars.report.options.upon_picking_up": "Lors de la reprise",
      "cars.report.options.handoff_to_service": "Remise au service",
      "cars.report.options.receiving_from_service": "Réception du service",
      "cars.report.options.already_exists": "(Existe déjà)",
      "cars.report.errors.mileage_positive": "Le kilométrage doit être supérieur à 0",
      "cars.report.errors.fuel_level_max": "Le niveau de carburant ne peut pas dépasser 100%",
      "cars.report.errors.detail_required": "La sélection du détail est requise",
      "cars.report.errors.select_all_details": "Veuillez sélectionner un détail pour tous les blocs ajoutés",
      "cars.report.create_success": "Rapport de voiture créé avec succès",
      "cars.report.create_error": "Échec de la création du rapport de voiture",
      "cars.report.edit_success": "Rapport de voiture mis à jour avec succès",
      "cars.report.edit_error": "Échec de la mise à jour du rapport de voiture",
      "cars.price_edit.save_success": "Prix enregistré avec succès",
      "cars.price_edit.save_error": "Échec de l'enregistrement du prix",
      "cars.price_edit.toggle_error": "Échec de la mise à jour de la visibilité du prix",
      "cars.delete.success": "Voiture supprimée avec succès",
      "cars.delete.error": "Échec de la suppression de la voiture",
      "rentings.datetime_edit.update_success": "Date/heure mise à jour avec succès",
      "rentings.datetime_edit.update_error": "Échec de la mise à jour de la date/heure",
      "rentings.address_edit.update_success": "Adresse mise à jour avec succès",
      "rentings.address_edit.update_error": "Échec de la mise à jour de l'adresse",
      "rentings.cancel.success": "Location annulée avec succès",
      "rentings.cancel.error": "Échec de l'annulation de la location",
      "rentings.confirm.success": "Location confirmée avec succès",
      "rentings.confirm.error": "Échec de la confirmation de la location",
      "rentings.comment.create_success": "Commentaire ajouté avec succès",
      "rentings.comment.create_error": "Échec de l'ajout du commentaire",
      "team.edit_user.save_success": "Utilisateur mis à jour avec succès",
      "team.edit_user.save_error": "Échec de la mise à jour de l'utilisateur",
      "profile.edit.save_success": "Profil mis à jour avec succès",
      "profile.edit.save_error": "Échec de la mise à jour du profil",
      "clients.verification.verify_success": "Client vérifié avec succès",
      "clients.verification.verify_error": "Échec de la vérification du client",
      "clients.verification.decline_success": "Vérification refusée",
      "clients.verification.decline_error": "Échec du refus de vérification",
      "car_models.delete.success": "Modèle de voiture supprimé avec succès",
      "car_models.delete.error": "Échec de la suppression du modèle de voiture",
      "car_models.status_toggle.success": "Statut changé avec succès",
      "car_models.status_toggle.error": "Échec du changement de statut",
      "activities.delete.success": "Activité supprimée avec succès",
      "activities.delete.error": "Échec de la suppression de l'activité"
    }
  }
};

// Ключ для сохранения языка в localStorage
const LANGUAGE_KEY = 'app_language';

// Получаем сохраненный язык из localStorage
const savedLanguage = localStorage.getItem(LANGUAGE_KEY) || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage, // Устанавливаем сохраненный язык
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false
    },

    // Настройки для использования ключа как fallback
    keySeparator: false,
    nsSeparator: false,
    returnNull: false,
    returnEmptyString: false
  });

// Добавляем обработчик изменения языка
i18n.on('languageChanged', (lng) => {
  localStorage.setItem(LANGUAGE_KEY, lng);
});

export default i18n;
